//import { Box } from "@mui/material";
import { GridSortItem } from "@mui/x-data-grid";
import { useState } from "react";
import { useParams } from "react-router-dom";
import CustomDataGridV2 from "../../../../../../../../components/CustomDataGridV2";
import Flex from "../../../../../../../../components/Flex";
// import ActionMenu from "../../../../../../../../components/app/ActionMenu";
import ChartTableWrapper from "../../../../../../../../components/app/provider/patient/add-new-patient/ChartTableWrapper";
import { useReduceDisclosure } from "../../../../../../../../hooks/use-reduce-disclosure";
import { useGetAllPatientAssessment } from "../../../../../../../../queries/patient-chart/assessment/assement-forms/use-get-all-patient-assessment";
import { formatDate } from "../../../../../../../../utils/date-time-utility";
import {
  DEF_PAGINATION,
  DGT_Pagination,
  applyDefaultColumnSettings,
  getXtenantId,
  // replaceUnderScoreAddSpace,
} from "../../../../../../../../utils/utils";
import SendPatientAssementFormsModal from "./SendPatientAssementFormsModal";

const PatientAssementForms = () => {
  const [sendAssementFormsDisclosure, _previewIntakeDisc] =
    useReduceDisclosure(2);
  const [pagination, setPagination] = useState<DGT_Pagination>(DEF_PAGINATION);
  const [_gridSorting, setGridSorting] = useState<GridSortItem[]>([]);
  const { patientId } = useParams();

  const { data: patientAssessments } = useGetAllPatientAssessment({
    patientId: patientId ?? "",
    pagination,
    xTENANTID: getXtenantId(),
    archive: false,
  });

  const COLUMNS = applyDefaultColumnSettings<any>([
    {
      field: "name",
      headerName: "Assessment Name",
      flex: 0.6,
      width: 200,
    },
    // {
    //   field: "formType",
    //   headerName: "Form Type",
    //   flex: 0.4,
    //   width: 150,
    // },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   flex: 0.4,
    //   width: 120,
    //   renderCell: ({ value }) =>
    //     value ? (
    //       <Box
    //         sx={{
    //           backgroundColor: value === "COMPLETED" ? "#E8F5E8" : "#FFF3E0",
    //           color: value === "COMPLETED" ? "#2E7D32" : "#F57C00",
    //           padding: "4px 8px",
    //           borderRadius: "4px",
    //           fontSize: "12px",
    //           fontWeight: 500,
    //         }}
    //       >
    //         {replaceUnderScoreAddSpace(value)}
    //       </Box>
    //     ) : (
    //       "-"
    //     ),
    // },
    {
      field: "created",
      headerName: "Sent On",
      flex: 0.5,
      width: 180,
      renderCell: ({ value }) => formatDate(value),
    },
    {
      field: "sendBy",
      headerName: "Sent By",
      flex: 0.5,
      width: 150,
      renderCell: ({ value }) => value || "-",
    },
    // {
    //   field: "submittedOn",
    //   headerName: "Submitted On",
    //   flex: 0.5,
    //   width: 180,
    //   renderCell: ({ value }) => formatDate(value) || "-",
    // },
    // {
    //   field: "submittedBy",
    //   headerName: "Submitted By",
    //   flex: 0.5,
    //   width: 150,
    //   renderCell: ({ value }) => value || "-",
    // },
    // {
    //   field: "Action",
    //   width: 90,
    //   hideSortIcons: true,
    //   align: "center",
    //   headerAlign: "center",
    //   renderCell: ({ row }) => (
    //     <ActionMenu
    //       options={[
    //         {
    //           value: "view",
    //           label: "View",
    //           // isDisabled: row?.status !== "COMPLETED",
    //           // hoverMsg: "View option is Available for Completed Forms only",
    //         },
    //         {
    //           value: "review",
    //           label: "Review",
    //         },
    //       ]}
    //       onActionClick={(v) => {
    //         console.log("action value", v);
    //         // console.log("val here check ", section.name);
    //         const sectionData = {
    //           section: row?.name,
    //           content: row?.content,
    //         };
    //         previewIntakeDisc.open(sectionData);
    //       }}
    //     />
    //   ),
    // },
  ]);

  return (
    <Flex
      flexDirection={"column"}
      width={"100%"}
      height={"calc(100vh - 373px)"}
      gap={1}
    >
      <SendPatientAssementFormsModal
        disclosureHost={sendAssementFormsDisclosure}
      />
      <ChartTableWrapper small={false}>
        <CustomDataGridV2
          getRowId={(row) => row?.uuid}
          rows={patientAssessments?.data?.content ?? []}
          rowCount={patientAssessments?.data?.page?.totalElements ?? 10}
          columns={COLUMNS}
          sx={{ marginTop: "40px" }}
          disableRowSelectionOnClick
          paginationModel={pagination}
          onPaginationModelChange={setPagination}
          onSortModelChange={setGridSorting}
        />
      </ChartTableWrapper>
    </Flex>
  );
};

export default PatientAssementForms;
